// extracted by mini-css-extract-plugin
export default {"input":"styles_input__lphrO","content":"styles_content__VQg-N","tips":"styles_tips__nsQZC","placeholder":"styles_placeholder__EJx7+","btn":"styles_btn__LzSpO"};